import { motion, useInView } from "framer-motion"
import { Link, graphql, useStaticQuery } from "gatsby"
import parse from "html-react-parser"
import React, { useEffect, useRef, useState } from "react"
import ImageOpt from "./ImageOpt"

const ItinerariesListing = ({ module }) => {
  const ref = useRef(null)
  const ref2 = useRef(null)
  const isInView = useInView(ref)
  const isInView2 = useInView(ref2)
  const [hasPlayed, setHasPlayed] = useState(false)
  const [hasPlayed2, setHasPlayed2] = useState(false)

  const sectionShow = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        duration: 0.5,
        ease: "easeOut",
        delayChildren: 0.5,
        staggerChildren: 0.2,
      },
    },
  }
  const animFade = {
    hidden: { opacity: 0, y: 20 },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: "easeInOut",
        delayChildren: 0.5,
        staggerChildren: 0.2,
      },
    },
  }
  useEffect(() => {
    if (isInView && !hasPlayed) {
      setHasPlayed(true)
    }
  }, [isInView, hasPlayed, setHasPlayed])

  useEffect(() => {
    if (isInView2 && !hasPlayed) {
      setHasPlayed2(true)
    }
  }, [isInView2, hasPlayed, setHasPlayed2])

  const itineData = useStaticQuery(graphql`
    query itineQuery {
      allWpItineraries(sort: { id: DESC }) {
        nodes {
          title
          excerpt
          uri
          featuredImage {
            node {
              altText
              mediaItemUrl
            }
          }
          itinerariesContent {
            facilities
            stay
          }
        }
      }
    }
  `)

  const allitineData = itineData.allWpItineraries.nodes
  const pageSize = 20
  const [itemsToDisplay, setItemsToDisplay] = useState(pageSize)
  const onLoadMore = () => {
    setItemsToDisplay(itemsToDisplay + pageSize)
  }

  if (module.hideSection === "no") {
    return (
      <React.Fragment>
        <motion.section
          initial="hidden"
          animate={isInView || hasPlayed ? "show" : "hidden"}
          variants={sectionShow}
          className={`zigzag-centered py-50 mdscreen:py-35 ${
            module.extraClass ? ` ${module.extraClass}` : ""
          }`}
          id={module.extraId}
        >
          {allitineData.slice(0, 1).map((item, i) => (
            <motion.div
              ref={ref}
              initial="hidden"
              animate={isInView || hasPlayed ? "show" : "hidden"}
              variants={sectionShow}
              className="container-fluid-md"
              key={i}
            >
              <Link to={item.uri} className="h-full">
                <div className="flex flex-wrap items-center">
                  <motion.div
                    variants={animFade}
                    className="lgscreen:w-full w-7/12 order-1 lg:order-1"
                  >
                    {item?.featuredImage && (
                      <div className="border-bg-offwhite">
                        <div className="img landscape">
                          <ImageOpt
                            imgData={item.featuredImage.node.mediaItemUrl}
                            imgAlt={item.featuredImage.node.title}
                            imgClass=""
                            width={2000}
                            height={1000}
                            imgLoad="lazy"
                          />
                        </div>
                      </div>
                    )}
                  </motion.div>
                  <div className="lgscreen:w-full w-5/12 order-2 lg:order-2 pl-25 lgscreen:pl-0 pt-30">
                    <motion.div
                      variants={animFade}
                      className="pre-heading separated w-full"
                    >
                      <ul>
                        {item.itinerariesContent.stay && (
                          <li>{item.itinerariesContent.stay}</li>
                        )}
                        {item.itinerariesContent.facilities && (
                          <li>{item.itinerariesContent.facilities}</li>
                        )}
                      </ul>
                    </motion.div>
                    <motion.div
                      variants={animFade}
                      className="title title-grey pt-20 lg:max-w-[368px] mx-auto"
                    >
                      <h3 className="lg:text-30 tracking-0.04em uppercase font-500 text-center">
                        {item.title}
                      </h3>
                    </motion.div>
                    {item?.excerpt && (
                      <motion.div
                        variants={animFade}
                        className="content pt-20 lg:max-w-[425px] mx-auto text-center"
                      >
                        {parse(item.excerpt)}
                      </motion.div>
                    )}
                    <motion.div
                      variants={animFade}
                      className="flex flex-wrap justify-center gap-x-30 lg:gap-x-40 xl:gap-x-50 pt-30"
                    >
                      <span className="btn btn-underline-grey">
                        Explore Itinerary
                      </span>
                    </motion.div>
                  </div>
                </div>
              </Link>
            </motion.div>
          ))}
        </motion.section>

        <motion.section
          initial="hidden"
          animate={isInView2 || hasPlayed2 ? "show" : "hidden"}
          variants={sectionShow}
          className="related-card-grid py-75 mdscreen:py-50 bg-white-200"
        >
          <motion.div
            ref={ref2}
            initial="hidden"
            animate={isInView2 || hasPlayed2 ? "show" : "hidden"}
            variants={sectionShow}
            className="container-fluid-md"
          >
            <div className="grid grid-cols-2 mdscreen2:grid-cols-1 gap-x-35 gap-y-65">
              {allitineData.slice(1, itemsToDisplay).map((item, k) => (
                <Link to={item.uri} className="h-full" key={k}>
                  <div className="flex flex-col justify-between items-center w-full h-full">
                    <div className="item_wrapper h-full w-full">
                      {item?.featuredImage && (
                        <motion.div variants={animFade} className="img">
                          <ImageOpt
                            imgData={item.featuredImage.node.mediaItemUrl}
                            imgAlt={item.featuredImage.node.title}
                            imgClass=""
                            width={2000}
                            height={1000}
                            imgLoad="lazy"
                          />
                        </motion.div>
                      )}
                      <div className="max-w-[430px] mx-auto pt-30 text-center">
                        <motion.div
                          variants={animFade}
                          className="pre-heading w-full separated pb-15"
                        >
                          <ul>
                            {item.itinerariesContent.stay && (
                              <li>{item.itinerariesContent.stay}</li>
                            )}
                            {item.itinerariesContent.facilities && (
                              <li>{item.itinerariesContent.facilities}</li>
                            )}
                          </ul>
                        </motion.div>
                        <motion.div
                          variants={animFade}
                          className="title title-grey"
                        >
                          <h5 className="font-500 tracking-0.04em uppercase">
                            {item.title}
                          </h5>
                        </motion.div>
                        {item?.excerpt && (
                          <motion.div
                            variants={animFade}
                            className="content pt-15"
                          >
                            {parse(item.excerpt)}
                          </motion.div>
                        )}
                      </div>
                    </div>
                    <motion.div
                      variants={animFade}
                      className="btn-custom pt-30"
                    >
                      <span className="btn btn-underline-grey">
                        Explore Itinerary
                      </span>
                    </motion.div>
                  </div>
                </Link>
              ))}
            </div>
            {allitineData.length > itemsToDisplay && (
              <motion.div
                variants={animFade}
                className="btn-custom mt-100 xlscreen:mt-80 mdscreen:mt-60 flex justify-center items-center"
              >
                <button onClick={onLoadMore} className="btn btn-grey">
                  Load More Itineraries
                </button>
              </motion.div>
            )}
          </motion.div>
        </motion.section>
      </React.Fragment>
    )
  }
  return null
}

export default ItinerariesListing
export const PageItinerariesListingFragment = graphql`
  fragment PageItinerariesListingFragment on WpPage_Pagecontent_PageContent_ItinerariesListing {
    extraClass
    extraId
    hideSection
  }
`
